exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\r\n.thumbnail{\r\n    width: 80px; height: 80px; border-radius: 100%;\r\n    background-size:cover; \r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// G:/MyProjects/Angular/oshop/src/app/shoping-cart/shoping-cart.component.css
// module id = ../../../../../src/app/shoping-cart/shoping-cart.component.css
// module chunks = main